import { apiClient } from '@/lib/api/client'
import type { FrameType } from '@/types/entities'

export const frameTypeApi = {
  getAllFrameTypes: async (): Promise<FrameType[]> => {
    const response = await apiClient.get('/api/frame-types')
    return response.data
  },

  getFrameType: async (frameTypeId: number): Promise<FrameType> => {
    const response = await apiClient.get(`/api/frame-types/${frameTypeId}`)
    return response.data
  },
}

